import React, { useState } from "react";

const getItem = key =>
  document.cookie.split("; ").reduce((total, currentCookie) => {
    const item = currentCookie.split("=");
    const storedKey = item[0];
    const storedValue = item[1];

    return key === storedKey ? decodeURIComponent(storedValue) : total;
  }, "");

const setItem = (key, value, ttl) => {
  const now = new Date();

  now.setTime(now.getTime() + ttl * 60 * 60 * 24 * 1000);

  document.cookie = `${key}=${value}; expires=${now.toUTCString()}; path=/`;
};

const useCookie = (key, defaultValue) => {
  const getCookie = () => getItem(key) || defaultValue;
  const [cookie, setCookie] = useState(getCookie());

  const updateCookie = (value, ttl=60) => {
    setCookie(value);
    setItem(key, value, ttl);
  };

  return [cookie, updateCookie];
};

export default useCookie;